export const AverageAnnualTotalReturnsMock = {
    mutualFund: {
        name: 'Global Technology Fund',
        inceptionDate: '2000-09-29T04:00:00Z',
        tackedReturnFundInceptionDate: null,
        standardPerformanceReturns: {
            monthlyAnnualReturns: {
                fundPerformance: {
                    asOfDate: '2023-12-31T05:00:00Z',
                    oneYearReturn: 55.92,
                    threeYearReturn: 48.61,
                    fiveYearReturn: 12.45,
                    tenYearReturn: 14.37,
                    sinceInceptionReturn: 7.95,
                    cumulativeSinceInceptionReturn: null,
                    oneYearReturnTacked: false,
                    threeYearReturnTacked: false,
                    fiveYearReturnTacked: false,
                    tenYearReturnTacked: false,
                    sinceInceptionReturnTacked: false,
                    __typename: 'YearlyReturns'
                }
            },
            quarterlyAnnualReturns: {
                fundPerformance: {
                    asOfDate: '2023-12-31T05:00:00Z',
                    oneYearReturn: 55.92,
                    threeYearReturn: 48.61,
                    fiveYearReturn: 12.45,
                    tenYearReturn: 14.37,
                    sinceInceptionReturn: 7.95,
                    oneYearReturnTacked: false,
                    threeYearReturnTacked: false,
                    fiveYearReturnTacked: false,
                    tenYearReturnTacked: false,
                    sinceInceptionReturnTacked: false,
                    __typename: 'YearlyReturns'
                }
            }
        },
        benchmarkPerformanceDetail: {
            benchmarkCode: 'SP500',
            benchmarkName: 'S&P 500 Index',
            primaryBenchmarkName:
                'MSCI All Country World Index Information Technology Net',
            primaryBenchmarkCode: 'ACITN',
            benchMarkPerformance: {
                oneYearReturn: 26.29,
                threeYearReturn: 10,
                fiveYearReturn: 15.69,
                tenYearReturn: 12.03,
                sinceInceptionReturn: 7.33,
                __typename: 'PerformanceDetail'
            },
            primaryBenchMarkPerformance: {
                oneYearReturn: 51.02,
                threeYearReturn: 9.86,
                fiveYearReturn: 23.18,
                tenYearReturn: 17.58,
                sinceInceptionReturn: 6.53,
                __typename: 'PerformanceDetail'
            },
            fundPerformance: {
                oneYearReturn: 55.92,
                threeYearReturn: -8.61,
                fiveYearReturn: 12.45,
                tenYearReturn: 14.37,
                sinceInceptionReturn: 7.95,
                __typename: 'PerformanceDetail'
            },
            __typename: 'BenchmarkPerformanceDetail'
        },
        __typename: 'GraphQLMutualFund'
    }
};

export const ThirtyDayMock = {
    fund: {
        thirtyDayAnnualizedDividendYieldAsOfDate: '2023-03-20T04:00:00Z',
        thirtyDayAnnualizedDividendYield: 2.54,
        unsubsidizedThirtyDaySECYieldAsOfDate: '2023-01-31T05:00:00Z',
        unsubsidizedThirtyDaySECYield: 4.1,
        yield30DayStandard: 4.1,
        yield30DayStandardEffectiveDate: '2023-01-31T05:00:00Z',
        inceptionDate: '1986-09-15T04:00:00Z',
        quarterlyAverageAnnualTotalReturns: {
            asOfDate: '2024-09-30T04:00:00Z'
        },
        __typename: 'GraphQLMutualFund'
    }
};

export const TopTenIssuersMock = {
    mutualFund: {
        name: 'Corporate Income Fund',
        inceptionDate: '1995-10-31T05:00:00Z',
        broadAssetClass: 'US Fixed Income',
        selectiveDisclosures: {
            quarterly: {
                asOfDate: '2024-11-30T05:00:00Z',
                totalHoldings: 101,
                top10CalculatedPercentage: 22.22,
                individualHoldings: [
                    {
                        name:
                            'San Francisco City & County Airport Comm-San Francisco International Airport',
                        rank: 1,
                        percentTotalNetAssets: 4.208,
                        issuerGuarantorTypeName: 'Guarantor',
                        __typename: 'IndividualHolding'
                    },
                    {
                        name: 'Cedars-Sinai Medical Center Obligated Group',
                        rank: 2,
                        percentTotalNetAssets: 2.22,
                        issuerGuarantorTypeName: 'Guarantor',
                        __typename: 'IndividualHolding'
                    },
                    {
                        name: 'University of California',
                        rank: 3,
                        percentTotalNetAssets: 2.12,
                        issuerGuarantorTypeName: 'Guarantor',
                        __typename: 'IndividualHolding'
                    },
                    {
                        name:
                            'Regents of The University of California Medical Center Pooled Revenue',
                        rank: 4,
                        percentTotalNetAssets: 2.01,
                        issuerGuarantorTypeName: 'Guarantor',
                        __typename: 'IndividualHolding'
                    },
                    {
                        name: 'City of Los Angeles Department of Airports',
                        rank: 5,
                        percentTotalNetAssets: 1.78,
                        issuerGuarantorTypeName: 'Guarantor',
                        __typename: 'IndividualHolding'
                    },
                    {
                        name: 'San Diego County Regional Airport Authority',
                        rank: 6,
                        percentTotalNetAssets: 1.34,
                        issuerGuarantorTypeName: 'Guarantor',
                        __typename: 'IndividualHolding'
                    },
                    {
                        name: 'Morgan Stanley',
                        rank: 7,
                        percentTotalNetAssets: 1.32,
                        issuerGuarantorTypeName: 'Guarantor',
                        __typename: 'IndividualHolding'
                    },
                    {
                        name: 'Lax Integrated Express Solutions LLC',
                        rank: 8,
                        percentTotalNetAssets: 1.17,
                        issuerGuarantorTypeName: 'Guarantor',
                        __typename: 'IndividualHolding'
                    },
                    {
                        name: 'San Diego Unified School District/Ca',
                        rank: 9,
                        percentTotalNetAssets: 1.555,
                        issuerGuarantorTypeName: null,
                        __typename: 'IndividualHolding'
                    },
                    {
                        name: 'County of Sacramento CA Airport System Revenue',
                        rank: 10,
                        percentTotalNetAssets: 1.1212,
                        issuerGuarantorTypeName: null,
                        __typename: 'IndividualHolding'
                    }
                ],
                __typename: 'SelectiveDisclosure'
            },
            monthly: [
                {
                    asOfDate: '2024-11-30T05:00:00Z',
                    totalHoldings: 101,
                    top10CalculatedPercentage: 23.55,
                    individualHoldings: [
                        {
                            name:
                                'San Francisco City & County Airport Comm-San Francisco International Airport',
                            rank: 1,
                            percentTotalNetAssets: 4.201,
                            issuerGuarantorTypeName: 'Guarantor',
                            __typename: 'IndividualHolding'
                        },
                        {
                            name: 'Cedars-Sinai Medical Center Obligated Group',
                            rank: 2,
                            percentTotalNetAssets: 2.47,
                            issuerGuarantorTypeName: 'Guarantor',
                            __typename: 'IndividualHolding'
                        },
                        {
                            name: 'University of California',
                            rank: 3,
                            percentTotalNetAssets: 2.44,
                            issuerGuarantorTypeName: 'Guarantor',
                            __typename: 'IndividualHolding'
                        },
                        {
                            name:
                                'Regents of The University of California Medical Center Pooled Revenue',
                            rank: 4,
                            percentTotalNetAssets: 2.43,
                            issuerGuarantorTypeName: 'Guarantor',
                            __typename: 'IndividualHolding'
                        },
                        {
                            name: 'City of Los Angeles Department of Airports',
                            rank: 5,
                            percentTotalNetAssets: 2.37,
                            issuerGuarantorTypeName: 'Guarantor',
                            __typename: 'IndividualHolding'
                        },
                        {
                            name: 'San Diego County Regional Airport Authority',
                            rank: 6,
                            percentTotalNetAssets: 2.25,
                            issuerGuarantorTypeName: 'Guarantor',
                            __typename: 'IndividualHolding'
                        },
                        {
                            name: 'Morgan Stanley',
                            rank: 7,
                            percentTotalNetAssets: 2.08,
                            issuerGuarantorTypeName: 'Guarantor',
                            __typename: 'IndividualHolding'
                        },
                        {
                            name: 'Lax Integrated Express Solutions LLC',
                            rank: 8,
                            percentTotalNetAssets: 1.98,
                            issuerGuarantorTypeName: 'Guarantor',
                            __typename: 'IndividualHolding'
                        },
                        {
                            name: 'San Diego Unified School District/Ca',
                            rank: 9,
                            percentTotalNetAssets: 1.7325,
                            issuerGuarantorTypeName: null,
                            __typename: 'IndividualHolding'
                        },
                        {
                            name:
                                'County of Sacramento CA Airport System Revenue',
                            rank: 10,
                            percentTotalNetAssets: 1.6,
                            issuerGuarantorTypeName: null,
                            __typename: 'IndividualHolding'
                        }
                    ],
                    __typename: 'SelectiveDisclosure'
                },
                {
                    asOfDate: '2024-10-31T04:00:00Z',
                    totalHoldings: 353,
                    top10CalculatedPercentage: 15.192,
                    individualHoldings: [
                        {
                            name: 'Citigroup',
                            rank: 1,
                            percentTotalNetAssets: 2.2155,
                            issuerGuarantorTypeName: null,
                            __typename: 'IndividualHolding'
                        },
                        {
                            name: 'SBA Communications',
                            rank: 2,
                            percentTotalNetAssets: 1.9978,
                            issuerGuarantorTypeName: null,
                            __typename: 'IndividualHolding'
                        },
                        {
                            name: 'CVS Health',
                            rank: 3,
                            percentTotalNetAssets: 1.678,
                            issuerGuarantorTypeName: null,
                            __typename: 'IndividualHolding'
                        },
                        {
                            name: 'Morgan Stanley',
                            rank: 4,
                            percentTotalNetAssets: 1.4959,
                            issuerGuarantorTypeName: null,
                            __typename: 'IndividualHolding'
                        },
                        {
                            name: 'AbbVie',
                            rank: 5,
                            percentTotalNetAssets: 1.4279,
                            issuerGuarantorTypeName: null,
                            __typename: 'IndividualHolding'
                        },
                        {
                            name: 'Charter Communications',
                            rank: 6,
                            percentTotalNetAssets: 1.3624,
                            issuerGuarantorTypeName: null,
                            __typename: 'IndividualHolding'
                        },
                        {
                            name:
                                'Health Care Service Corp A Mutual Legal Reserve',
                            rank: 7,
                            percentTotalNetAssets: 1.284,
                            issuerGuarantorTypeName: null,
                            __typename: 'IndividualHolding'
                        },
                        {
                            name: 'Rogers Communications',
                            rank: 8,
                            percentTotalNetAssets: 1.2806,
                            issuerGuarantorTypeName: null,
                            __typename: 'IndividualHolding'
                        },
                        {
                            name: 'Goldman Sachs',
                            rank: 9,
                            percentTotalNetAssets: 1.246,
                            issuerGuarantorTypeName: null,
                            __typename: 'IndividualHolding'
                        },
                        {
                            name: 'ONEOK',
                            rank: 10,
                            percentTotalNetAssets: 1.2039,
                            issuerGuarantorTypeName: null,
                            __typename: 'IndividualHolding'
                        }
                    ],
                    __typename: 'SelectiveDisclosure'
                },
                {
                    asOfDate: '2024-09-30T04:00:00Z',
                    totalHoldings: 0,
                    top10CalculatedPercentage: 15.079699999999999,
                    individualHoldings: [
                        {
                            name: 'Citigroup',
                            rank: 1,
                            percentTotalNetAssets: 8.888,
                            issuerGuarantorTypeName: null,
                            __typename: 'IndividualHolding'
                        },
                        {
                            name: 'SBA Communications',
                            rank: 2,
                            percentTotalNetAssets: 1.9783,
                            issuerGuarantorTypeName: null,
                            __typename: 'IndividualHolding'
                        },
                        {
                            name: 'CVS Health',
                            rank: 3,
                            percentTotalNetAssets: 1.7097,
                            issuerGuarantorTypeName: null,
                            __typename: 'IndividualHolding'
                        },
                        {
                            name: 'AbbVie',
                            rank: 4,
                            percentTotalNetAssets: 1.452,
                            issuerGuarantorTypeName: null,
                            __typename: 'IndividualHolding'
                        },
                        {
                            name: 'Wells Fargo',
                            rank: 5,
                            percentTotalNetAssets: 1.4361,
                            issuerGuarantorTypeName: null,
                            __typename: 'IndividualHolding'
                        },
                        {
                            name:
                                'Health Care Service Corp A Mutual Legal Reserve',
                            rank: 6,
                            percentTotalNetAssets: 1.2975,
                            issuerGuarantorTypeName: null,
                            __typename: 'IndividualHolding'
                        },
                        {
                            name: 'Rogers Communications',
                            rank: 7,
                            percentTotalNetAssets: 1.2751,
                            issuerGuarantorTypeName: null,
                            __typename: 'IndividualHolding'
                        },
                        {
                            name: 'Morgan Stanley',
                            rank: 8,
                            percentTotalNetAssets: 1.2716,
                            issuerGuarantorTypeName: null,
                            __typename: 'IndividualHolding'
                        },
                        {
                            name: 'Goldman Sachs',
                            rank: 9,
                            percentTotalNetAssets: 1.2565,
                            issuerGuarantorTypeName: null,
                            __typename: 'IndividualHolding'
                        },
                        {
                            name: 'ONEOK',
                            rank: 10,
                            percentTotalNetAssets: 1.1953,
                            issuerGuarantorTypeName: null,
                            __typename: 'IndividualHolding'
                        }
                    ],
                    __typename: 'SelectiveDisclosure'
                },
                {
                    asOfDate: '2024-06-30T04:00:00Z',
                    totalHoldings: 0,
                    top10CalculatedPercentage: 14.7951,
                    individualHoldings: [
                        {
                            name: 'Banco Santander',
                            rank: 1,
                            percentTotalNetAssets: 2.2957,
                            issuerGuarantorTypeName: null,
                            __typename: 'IndividualHolding'
                        },
                        {
                            name: 'Citigroup',
                            rank: 2,
                            percentTotalNetAssets: 1.9477,
                            issuerGuarantorTypeName: null,
                            __typename: 'IndividualHolding'
                        },
                        {
                            name: 'Morgan Stanley',
                            rank: 3,
                            percentTotalNetAssets: 1.4412,
                            issuerGuarantorTypeName: null,
                            __typename: 'IndividualHolding'
                        },
                        {
                            name: 'AbbVie',
                            rank: 4,
                            percentTotalNetAssets: 1.3993,
                            issuerGuarantorTypeName: null,
                            __typename: 'IndividualHolding'
                        },
                        {
                            name: 'Charter Communications',
                            rank: 5,
                            percentTotalNetAssets: 1.3949,
                            issuerGuarantorTypeName: null,
                            __typename: 'IndividualHolding'
                        },
                        {
                            name: 'Solventum',
                            rank: 6,
                            percentTotalNetAssets: 1.3652,
                            issuerGuarantorTypeName: null,
                            __typename: 'IndividualHolding'
                        },
                        {
                            name: 'Rogers Communications',
                            rank: 7,
                            percentTotalNetAssets: 1.2735,
                            issuerGuarantorTypeName: null,
                            __typename: 'IndividualHolding'
                        },
                        {
                            name:
                                'Health Care Service Corp A Mutual Legal Reserve',
                            rank: 8,
                            percentTotalNetAssets: 1.2482,
                            issuerGuarantorTypeName: null,
                            __typename: 'IndividualHolding'
                        },
                        {
                            name: 'Goldman Sachs',
                            rank: 9,
                            percentTotalNetAssets: 1.2435,
                            issuerGuarantorTypeName: null,
                            __typename: 'IndividualHolding'
                        },
                        {
                            name: 'CVS Health',
                            rank: 10,
                            percentTotalNetAssets: 1.1859,
                            issuerGuarantorTypeName: null,
                            __typename: 'IndividualHolding'
                        }
                    ],
                    __typename: 'SelectiveDisclosure'
                }
            ],
            __typename: 'SelectiveDisclosures'
        },
        __typename: 'GraphQLMutualFund'
    }
};

export const PerformanceMock = {
    exchangeTradedFund: {
        name: 'T. Rowe Price Capital Appreciation Premium Income ETF',
        ticker: 'TCAL',
        inceptionDate: '2025-03-26T04:00:00Z',
        benchmarks: [
            {
                benchmarkCode: 'BXM',
                benchmarkName: 'CBOE S&P 500 BuyWrite Index',
                benchmarkType: 'Primary',
                __typename: 'ETFBenchmark'
            },
            {
                benchmarkCode: 'SP500',
                benchmarkName: 'S&P 500 Index',
                benchmarkType: 'Secondary',
                __typename: 'ETFBenchmark'
            },
            {
                benchmarkCode: 'RUS30',
                benchmarkName: 'Russell 3000 Index',
                benchmarkType: 'Regulatory',
                __typename: 'ETFBenchmark'
            }
        ],
        contributionGrowth: {
            effectiveDate: '2025-03-31T00:00:00Z',
            fundGrowthAmounts: [
                {
                    asOfDate: '2025-03-26T00:00:00Z',
                    balance: 10000,
                    __typename: 'GrowthAmount'
                }
            ],
            benchmarkContributionGrowths: [
                {
                    benchmarkSymbol: 'SP500',
                    benchmarkName: ' S&P 500 Index',
                    defaultBenchmarkIndicator: false,
                    growthAmounts: [
                        {
                            asOfDate: '2025-03-26T00:00:00Z',
                            balance: 10000,
                            __typename: 'GrowthAmount'
                        }
                    ],
                    __typename: 'BenchmarkContributionGrowth'
                },
                {
                    benchmarkSymbol: 'BXM',
                    benchmarkName: ' CBOE S&P 500 BuyWrite Index',
                    defaultBenchmarkIndicator: true,
                    growthAmounts: [
                        {
                            asOfDate: '2025-03-26T00:00:00Z',
                            balance: 10000,
                            __typename: 'GrowthAmount'
                        }
                    ],
                    __typename: 'BenchmarkContributionGrowth'
                }
            ],
            __typename: 'ContributionGrowth'
        },
        __typename: 'ExchangeTradedFund'
    }
};

export const CalendarYearTotalReturnsMock = {
    mutualFund: {
        name: 'Global Value Equity Fund',
        iClass: false,
        inceptionDate: '2020-03-02T05:00:00Z',
        tenYearHistoricalReturns: [],
        correspondingFund: {
            inceptionDate: '2012-07-26T04:00:00Z',
            tenYearHistoricalReturns: [
                {
                    fundReturn: null,
                    asOfDate: '2015-12-31T05:00:00Z',
                    __typename: 'FundReturn'
                },
                {
                    fundReturn: null,
                    asOfDate: '2016-12-31T05:00:00Z',
                    __typename: 'FundReturn'
                },
                {
                    fundReturn: null,
                    asOfDate: '2017-12-31T05:00:00Z',
                    __typename: 'FundReturn'
                },
                {
                    fundReturn: null,
                    asOfDate: '2018-12-31T05:00:00Z',
                    __typename: 'FundReturn'
                },
                {
                    fundReturn: null,
                    asOfDate: '2019-12-31T05:00:00Z',
                    __typename: 'FundReturn'
                },
                {
                    fundReturn: null,
                    asOfDate: '2020-12-31T05:00:00Z',
                    __typename: 'FundReturn'
                },
                {
                    fundReturn: 15.81,
                    asOfDate: '2021-12-31T05:00:00Z',
                    __typename: 'FundReturn'
                },
                {
                    fundReturn: -8.07,
                    asOfDate: '2022-12-31T05:00:00Z',
                    __typename: 'FundReturn'
                },
                {
                    fundReturn: 13.04,
                    asOfDate: '2023-12-31T05:00:00Z',
                    __typename: 'FundReturn'
                },
                {
                    fundReturn: 16.78,
                    asOfDate: '2024-12-31T05:00:00Z',
                    __typename: 'FundReturn'
                }
            ],
            __typename: 'GraphQLMutualFund'
        },
        standardPerformanceReturns: {
            quarterlyAnnualReturns: {
                fundPerformance: {
                    oneYearReturnTacked: true,
                    threeYearReturnTacked: true,
                    fiveYearReturnTacked: true,
                    tenYearReturnTacked: true,
                    sinceInceptionReturnTacked: true,
                    __typename: 'YearlyReturns'
                },
                __typename: 'FundAverageAnnualTotalReturn'
            },
            __typename: 'StandardPerformanceReturns'
        },
        __typename: 'GraphQLMutualFund'
    }
};
